 /* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import {connect} from 'react-redux';
import {isUndefined} from 'lodash';
import {withRouter} from 'react-router-dom';

import {segmentEventTracker} from '../../../utils/SegmentEventTracker';
import {PageName} from '../constants/SegmentEvents';

// This is very important for our segment event tracking.
// TODO: Make sure to check if page name is set
// and same with the names set in this spreadsheet
// https://docs.google.com/spreadsheets/d/1TMteCzOibuvFidvoRwNOQkSgcnra_nalxSZMqwuJNRo/edit#gid=1953686218

export class Segment extends Component {
  // For scenarios where user
  // refreshes the page
  componentDidMount() {
    this.setPageInSegmentContext();
  }

  componentDidUpdate(prevProps) {
    const {user, location} = this.props;

    if (
      !isUndefined(prevProps.user.onboarding_finished) &&
      prevProps.user.onboarding_finished !== user.onboarding_finished
    ) {
      this.handlePageNameInRequirements();
    }

    if (prevProps.location.pathname !== location.pathname) {
      this.setPageInSegmentContext();
    }
  }

  pageNameFromUrl() {
    // This can be in a util but for
    // now let's put it here.
    //
    // Routes we can't handle here
    // '/'
    // It's because we are showing multiple screens
    // and will have a different page name for every page state
    // like in requirements and home.
    // Just handle the routes here that is specific and will not change
    //
    // TODO: handle article of partnerships when released
    // TODO: handle trade doc page for resubmission
    // TODO: handle trade doc contact menu modal
    // TODO: handle trade doc contact form
    // TODO: handle reset password with expired screen
    // TODO: handle trustpass doc uploads states in containers
    // TODO: handle credit boosts URL's
    // for example when primary id is marked for resubmission

    const path = this.props.location.pathname;
    const pathArray = path.split('/');

    // Handle requirements
    if (path === '/requirements') {
      return this.handlePageNameInRequirements();
    }

    // handle purchase orders
    if (pathArray.includes('purchase_orders') && pathArray.includes('new')) {
      return PageName.PURCHASE_ORDER_UPLOAD_ONE;
    }
    if (
      pathArray.includes('purchase_orders') &&
      pathArray.includes('supporting_documents')
    ) {
      return PageName.TRADE_DOC_ADD_SUPPORTING_DOC;
    }

    // handle invoices
    if (pathArray.includes('invoices') && pathArray.includes('new')) {
      return PageName.INVOICE_UPLOAD_ONE;
    }
    if (
      pathArray.includes('invoices') &&
      pathArray.includes('supporting_documents')
    ) {
      return PageName.TRADE_DOC_ADD_SUPPORTING_DOC;
    }

    // pending loan offers
    // handle check upload page name in container
    if (
      pathArray.includes('pending_loan_offers') &&
      pathArray.includes('review')
    ) {
      return PageName.LOAN_OFFER_ACCEPTANCE_SUMMARY;
    }
    if (
      pathArray.includes('pending_loan_offers') &&
      pathArray.includes('loan_terms')
    ) {
      return PageName.LOAN_OFFER_ACCEPTANCE_LOAN_TERMS;
    }
    if (
      pathArray.includes('pending_loan_offers') &&
      pathArray.includes('sign_loan_agreement')
    ) {
      return PageName.LOAN_OFFER_ACCEPTANCE_LOAN_AGREEMENT;
    }

    if (pathArray.includes('loan_plan_overview')) {
      return PageName.LOAN_DETAILS;
    }

    if (path === '/login') {
      return PageName.LOGIN;
    } else if (path === '/forgot_password') {
      return PageName.FORGOT_PASSWORD;
    } else if (path === '/apply') {
      return PageName.APPLY_FLOW;
    } else if (path === '/applications') {
      return PageName.APPLICATIONS;
    } else if (path === '/apply/success') {
      return PageName.APPLY_FLOW_SUCCESS;
    } else if (path === '/company_information') {
      return PageName.COMPANY_INFORMATION;
    } else if (path === '/personal_trustpass/information/new') {
      return PageName.ONBOARDING_PERSONAL_INFO;
    } else if (path === '/business_trustpass/information/new') {
      return PageName.ONBOARDING_BUSINESS_INFO;
    } else if (path === '/user_profile') {
      return PageName.MY_ACCOUNT;
    } else if (path === '/loan_plans') {
      return PageName.LOANS;
    } else if (path === '/notifications') {
      return PageName.NOTIFICATIONS;
    } else if (/^\/(invoices|purchase_orders)\/\d+\/add_contact$/.test(path)) {
      return PageName.ADD_CONTACT;
    } else if (path === '/credit-boost') {
      return PageName.CREDIT_BOOST_SUMMARY;
    } else if (path === '/credit-boost/document/new') {
      return PageName.CREDIT_BOOST_UPLOAD;
    } else if (path === '/reset_password') {
      return PageName.RESET_PASSWORD;
    } else if (path === '/email_sent') {
      return PageName.FORGOT_PASSWORD;
    }
  }

  handlePageNameInRequirements() {
    const {user} = this.props;
    const pageName = user.onboarding_finished
      ? PageName.REQUIREMENTS_ALL_COMPLETE
      : PageName.REQUIREMENTS;

    segmentEventTracker.setContext({page_name: pageName});
    return pageName;
  }

  setPageInSegmentContext() {
    segmentEventTracker.setContext({page_name: this.pageNameFromUrl()});
  }

  // don't need to show anything
  render() {
    return null;
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
  };
};

export default withRouter(connect(mapStateToProps)(Segment));



// WEBPACK FOOTER //
// ./src/features/shared/containers/Segment.js